<template>
  <div id="contacts-tab" class="tab is-full-height">
    <div v-if="estimators.length">

      <div class="card">
        <div class="card-header">
          <p class="card-header-title">{{clientName}} Contacts</p>
        </div>
        <div class="card-content">
          <IndexTable
              :columns="defaultEstimatorTableColumns"
              default-status-filter="active"
              :display-status-filter="false"
              :items="estimators"
              resource="user"
              title="Internal Contacts"
              :display-actions="false"
              :displaySettings="false"
          />
        </div>
      </div>
    </div>
  <hr v-if="estimators.length && contacts.length" />
    <div v-if="contacts.length">
      <div class="card">
        <div class="card-header">
          <p class="card-header-title">Other Project Contacts</p>
        </div>
        <div class="card-content">
          <IndexTable
              :columns="defaultContactTableColumns"
              default-status-filter="active"
              :display-status-filter="false"
              :items="contacts"
              resource="project-contact"
              title="External Contacts"
              :display-actions="false"
              :displaySettings="false"
          />
        </div>
      </div>
    </div>

  </div>
</template>

<script setup lang="ts">

import {computed, toRefs} from "vue";
import {storeToRefs} from "pinia";
import IndexTable from "@/components/IndexTable.vue";
import {usePublicProjectStore} from "@/stores/PublicProjectStore";
import {useProjectStore} from "@/stores/ProjectStore";
import {useBidPackageStore} from "@/stores/BidPackageStore";
import {useClientStore} from '@/stores/ClientStore';

const projectStore = useProjectStore();
const publicProjectStore = usePublicProjectStore();
const {client} = storeToRefs(useClientStore());
const { bidPackage } = storeToRefs(useBidPackageStore());
const defaultEstimatorTableColumns = [
  // {
  //   field: 'id',
  //   label: 'ID',
  //   width: 40,
  //   numeric: true,
  // },
  {
    field: 'company_name',
    label: 'Company',
    sortable: true,
  },
  {
    field: 'name',
    label: 'Name',
    sortable: true,
  },
  {
    field: 'display_title',
    label: 'Title',
    sortable: true,
  },
  {
    field: 'phone_number',
    label: 'Phone',
    component: 'PhoneColumn',
    sortable: true,
  },
  {
    field: 'extension',
    label: 'Extension',
    sortable: true,
  },
  {
    field: 'fax_number',
    label: 'Fax',
    component: 'PhoneColumn',
    sortable: true,
  },
  {
    field: 'email',
    label: 'Email',
    sortable: true,
  },
];
const defaultContactTableColumns = [
  // {
  //   field: 'id',
  //   label: 'ID',
  //   width: 40,
  //   numeric: true,
  // },
  {
    field: 'company_name',
    label: 'Company',
    sortable: true,
  },
  {
    field: 'name',
    label: 'Name',
    sortable: true,
  },
  {
    field: 'label',
    label: 'Title',
    sortable: true,
  },
  {
    field: 'phone_number',
    label: 'Phone',
    component: 'PhoneColumn',
    sortable: true,
  },
  {
    field: 'extension',
    label: 'Extension',
    sortable: true,
  },
  {
    field: 'fax_number',
    label: 'Fax',
    component: 'PhoneColumn',
    sortable: true,
  },
  {
    field: 'email',
    label: 'Email',
    sortable: true,
  },
];

const props = withDefaults(defineProps<{
  bidPackageId: number | null,
  publicProjectView?: boolean,
}>(), {
  bidPackageId: null,
  publicProjectView: false,
});
const {
  bidPackageId,
  publicProjectView,
} = toRefs(props);

const clientName = computed(() => client.value?.name || project.value?.client?.name || 'Project');

const estimators = computed(() => (
  (bidPackageId.value ? bidPackage.value?.estimators : project.value?.estimators) || []
).map(estimator => ({
  ...estimator,
  display_title: estimator.label?.trim() || estimator.title?.trim() || 'Estimator',
})));

const contacts = computed(() => (bidPackageId.value ? bidPackage.value?.project_contacts : project.value?.project_contacts) || []);

const project = computed(() => publicProjectView.value ? publicProjectStore.project : projectStore.project);

</script>

<style lang="scss" scoped>

#contacts-tab {

  .box {
    overflow-x: auto;
  }

}

</style>